import { startTransition } from "react";
import { useTranslation } from "react-i18next";

const CategoryChipBar = ({ chips, activeChip, onSelect }) => {
  const { t } = useTranslation();
  const handleClick = (key) => {
    // Mark as non-urgent — keeps UI responsive while shelves swap
    startTransition(() => onSelect(key));
  };

  return (
    <div
      className="flex items-center gap-2 overflow-x-auto scrollbar-hide py-2"
      style={{ scrollbarWidth: "none" }}
    >
      {chips.map((chip) => {
        const isActive = activeChip === chip.key;
        return (
          <button
            key={chip.key}
            onClick={() => handleClick(chip.key)}
            className={`relative shrink-0 inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-semibold transition-all whitespace-nowrap border ${
              isActive
                ? "bg-primary text-white border-primary"
                : "bg-white/5 text-white/70 hover:text-white border-white/10 hover:border-white/20"
            }`}
          >
            {chip.icon && <span className="inline-flex">{chip.icon}</span>}
            {chip.label}
            {chip.comingSoon && (
              <span className="ms-1 text-[9px] uppercase tracking-wider font-bold px-1.5 py-0.5 rounded-full bg-amber-500/25 text-amber-300 border border-amber-400/40">
                {t("library.coming_soon") || "Soon"}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default CategoryChipBar;
